import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import { FilterByArrayPipe } from '../core/pipes/filter-by-array.pipe';
import {FilterByPipe} from '../core/pipes/filter-by.pipe';
import { SortPipe } from '../core/pipes/sort.pipe';
import {TruncateString} from '../core/pipes/truncate-string';
import {DateTransformPipe} from './date-transform.pipe';
import {FineDocNumberPipe} from './fine-doc-number.pipe';
import {FineDocSearchPipe} from './fine-doc-search';
import {FineNumberPipe} from './fine-number.pipe';
import {NpFinePhonePipe} from './np-fine-phone.pipe';
import {ToDateFormatPipe} from './to-date-format.pipe';
import { DeliveryDatePipe } from '../core/pipes/delivery-date.pipe';
import { DigitRoundPipe } from '../core/pipes/digit-round.pipe';
import { SafeUrlPipe } from '../core/pipes/safe-url.pipe';

@NgModule({
  declarations: [
    FineDocNumberPipe,
    FineDocSearchPipe,
    FineNumberPipe,
    NpFinePhonePipe,
    ToDateFormatPipe,
    FilterByPipe,
    FilterByArrayPipe,
    TruncateString,
    DateTransformPipe,
    SortPipe,
    DeliveryDatePipe,
    DigitRoundPipe,
    SafeUrlPipe,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    FineDocNumberPipe,
    FineDocSearchPipe,
    FineNumberPipe,
    NpFinePhonePipe,
    ToDateFormatPipe,
    FilterByPipe,
    FilterByArrayPipe,
    TruncateString,
    DateTransformPipe,
    SortPipe,
    DeliveryDatePipe,
    DigitRoundPipe,
    SafeUrlPipe,
  ],
})
export class PipeModule {
}
